import api from './axiosInstance'

export default {
    addMasterConstants(payload) {
        return api.post('masterConstants', payload);
    },
    updateMasterConstants(id, payload) {
        return api.put('masterConstants/' + id, payload);
    },
    getAllMasterConstants() {
        return api.get('masterConstants');
    },
}